import script from "./WallpaperStats.vue?vue&type=script&setup=true&lang=js"
export * from "./WallpaperStats.vue?vue&type=script&setup=true&lang=js"

import "./WallpaperStats.vue?vue&type=style&index=0&id=21eea868&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\data_dashboard\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21eea868"]])

export default __exports__